export enum VtmnPlayButtonShapeEnum {
  ROUNDED = 'rounded',
  SQUARED = 'squared',
}
